import React from "react";
import { notFound } from "../data/data";
import "./NotFound.css";

const NotFound = () => {
  return (
    <section className="notfound">
      <h1>{notFound.heading}</h1>
      <p>{notFound.message}</p>
      <a href="/" className="notfound-btn">
        {notFound.backToHome}
      </a>
    </section>
  );
};

export default NotFound;
